import { render, staticRenderFns } from "./DistributorHistorical.vue?vue&type=template&id=1a5ab7c8&scoped=true"
import script from "./DistributorHistorical.vue?vue&type=script&lang=js"
export * from "./DistributorHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ab7c8",
  null
  
)

export default component.exports